import './error.css';

import { 
    Widget, 
    Icon,
} from '../components';

export function Error(props) {
    return (
        <Widget variant="alert" class="error-widget">
            <Icon name="ic_alert-outline" class="error-icon" />
            <p className="error-text">
                {props.text}
            </p>
            {props.children}
        </Widget>
    );
}